import { render } from "./LogApiCalls.vue?vue&type=template&id=2ede5c39&scoped=true"
import script from "./LogApiCalls.vue?vue&type=script&lang=js"
export * from "./LogApiCalls.vue?vue&type=script&lang=js"

import "./LogApiCalls.vue?vue&type=style&index=0&id=2ede5c39&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ede5c39"]])

export default __exports__